import structDataFuns from "./common/structData";

import emrInfoPanel from "./components/emrInfoPanel";
import emrInfoDialog from "./components/emrInfoDialog";

import { apiFuns, storeFuns } from "sw-hic";

const components = [emrInfoPanel, emrInfoDialog];

const install = function (Vue) {
  if (install.installed) return;

  install.installed = true;

  // 组件
  components.forEach((com) => {
    Vue.component(com.name, com);
  });

  // 装载必须用到的字典
  storeFuns.genDict("MrTemplate", () => apiFuns.get("/api/emr/tmpl"));
  storeFuns.genDict("MrElement", () => apiFuns.get("/api/emr/element"));
};

export default {
  install,
  ...components,
};

export { emrInfoPanel, emrInfoDialog, structDataFuns };
